"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProficiencyTestStore = void 0;
const pinia_1 = require("pinia");
const ProficiencyTest_1 = __importDefault(require("../src/api/ProficiencyTest"));
const get_1 = __importDefault(require("lodash/get"));
/**
 * Order a test's sections and the questions and
 * answers within it by their order attributes
 */
function orderTestParts(test) {
    if (test === null) {
        return null;
    }
    test.sections = test.sections.sort((a, b) => {
        return a.order - b.order;
    });
    test.sections.map((section) => {
        section.questions.sort((a, b) => {
            return a.order - b.order;
        });
        section.questions.map((question) => {
            question.answers.sort((a, b) => {
                return a.order - b.order;
            });
            return question;
        });
        return section;
    });
    return test;
}
exports.useProficiencyTestStore = (0, pinia_1.defineStore)('proficiencyTest', {
    state: () => {
        return {
            test: null,
            detailsProvided: false,
            submission: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                history: [],
                test: '',
                results: {
                    sections: {},
                    category: null,
                },
            },
            currentSectionIndex: null,
            currentQuestionIndex: null,
            currentQuestionAnswered: false,
            currentAnswer: null,
            answerSubmitted: false,
            consecutiveCorrectAnswerCount: 0,
            consecutiveWrongAnswerCount: 0,
            correctAnswerCount: 0,
            wrongAnswerCount: 0,
            showSkipModal: false,
            complete: false,
            finalCorrectAnswerCount: 0,
            recommendedCategory: null,
        };
    },
    actions: {
        getCurrentTest() {
            return __awaiter(this, void 0, void 0, function* () {
                ProficiencyTest_1.default.getCurrentTest()
                    .then((response) => {
                    this.test = orderTestParts((0, get_1.default)(response, 'data.data'));
                })
                    .catch((error) => {
                    console.error(error);
                });
            });
        },
        getTest(slug) {
            return __awaiter(this, void 0, void 0, function* () {
                ProficiencyTest_1.default.getTest(slug)
                    .then((response) => {
                    this.test = orderTestParts((0, get_1.default)(response, 'data.data'));
                })
                    .catch((error) => {
                    console.error(error);
                });
            });
        },
        submitTest() {
            return __awaiter(this, void 0, void 0, function* () {
                return ProficiencyTest_1.default.submit(this.submission).then(() => {
                    this.detailsProvided = true;
                });
            });
        },
        answerQuestion(answerId, wasCorrect) {
            if (!this.currentSection) {
                return;
            }
            if (wasCorrect) {
                this.consecutiveCorrectAnswerCount++;
                this.correctAnswerCount++;
                this.consecutiveWrongAnswerCount = 0;
            }
            else {
                this.wrongAnswerCount++;
                this.consecutiveWrongAnswerCount++;
                this.consecutiveCorrectAnswerCount = 0;
            }
            if (this.consecutiveCorrectAnswerCount === this.correctAnswerLimit && this.currentSectionIndex !== this.test.sections.length - 1) {
                this.showSkipModal = true;
            }
            this.storeAnswerValue(this.currentSection.id, this.currentQuestion.id, answerId, wasCorrect);
            if (this.consecutiveWrongAnswerCount === this.wrongAnswerLimit) {
                this.endEarly();
            }
            this.updateFinalCorrectAnswerCount();
            this.answerSubmitted = true;
        },
        storeAnswerValue(sectionId, questionId, answerId, wasCorrect, skipped = false) {
            this.$patch((state) => {
                if (typeof state.submission.results.sections[sectionId] === 'undefined') {
                    state.submission.results.sections[sectionId] = {
                        skipped: skipped,
                        questions: {
                            [questionId]: {
                                answer: answerId,
                                correct: wasCorrect,
                            }
                        }
                    };
                }
                state.submission.results.sections[sectionId].skipped = skipped;
                state.submission.results.sections[sectionId].questions[questionId] = {
                    answer: answerId,
                    correct: wasCorrect,
                };
            });
        },
        endEarly() {
            this.showSkipModal = false;
            this.recommendedCategory = this.getRecommendedCategory();
            // Count rest of questions in current section as wrong
            for (let q = this.currentQuestionIndex + 1; q < this.currentSection.questions.length; q++) {
                this.storeAnswerValue(this.currentSection.id, this.currentSection.questions[q].id, 0, false, false);
            }
            // Count the all questions in remaining sections as wrong
            if (this.currentSectionIndex !== this.test.sections.length - 1) {
                for (let s = this.currentSectionIndex + 1; s < this.test.sections.length; s++) {
                    for (let q = 0; q < this.test.sections[s].questions.length; q++) {
                        this.storeAnswerValue(this.test.sections[s].id, this.test.sections[s].questions[q].id, 0, false, false);
                    }
                }
            }
            this.showEndScreen();
        },
        getRecommendedCategory() {
            const categorySplit = this.currentSection.questions.length / (this.currentSection.categories.length + 1);
            // See if user should be assigned any of the categories in this section
            for (let i = 0; i < this.currentSection.categories.length; i++) {
                const category = this.currentSection.categories[i];
                const limit = categorySplit * (i + 1);
                if (this.correctAnswerCount < limit) {
                    // Set initial state
                    this.recommendCategory(category);
                    return category;
                }
            }
            return null;
        },
        nextQuestion() {
            if (this.currentQuestionIndex === this.currentSection.questions.length - 1) {
                const recommendCategory = this.getRecommendedCategory();
                if (recommendCategory) {
                    this.recommendCategory(recommendCategory);
                    this.showEndScreen();
                    return;
                }
                this.nextSection();
            }
            else {
                this.currentQuestionIndex++;
            }
            this.currentAnswer = null;
            this.answerSubmitted = false;
        },
        nextSection() {
            if (this.currentQuestionIndex === null || this.test === null) {
                return;
            }
            // Was the last section, so they're very good and get assigned
            // the highest category - the one associated with the test
            // not the section
            if (this.currentSectionIndex === this.test.sections.length - 1) {
                this.recommendCategory(this.test.category);
                this.showEndScreen();
                return;
            }
            // User can go on to the next section
            this.currentSectionIndex++;
            this.currentQuestionIndex = 0;
            this.correctAnswerCount = 0;
            this.consecutiveCorrectAnswerCount = 0;
            this.wrongAnswerCount = 0;
            this.consecutiveWrongAnswerCount = 0;
            this.currentAnswer = null;
            this.answerSubmitted = false;
        },
        recommendCategory(category) {
            this.recommendedCategory = category;
            this.$state.submission.results.category = category.slug;
        },
        skipToNextSection() {
            // Count rest of questions in current section as right
            for (let q = this.currentQuestionIndex; q < this.currentSection.questions.length; q++) {
                this.storeAnswerValue(this.currentSection.id, this.currentSection.questions[q].id, 0, true, true);
            }
            this.nextSection();
        },
        updateFinalCorrectAnswerCount() {
            let count = 0;
            for (let s = 0; s < Object.values(this.submission.results.sections).length; s++) {
                const section = Object.values(this.submission.results.sections)[s];
                for (let q = 0; q < Object.values(section.questions).length; q++) {
                    const question = Object.values(section.questions)[q];
                    if (question.correct) {
                        count++;
                    }
                }
            }
            this.finalCorrectAnswerCount = count;
        },
        showEndScreen() {
            this.updateFinalCorrectAnswerCount();
            this.complete = true;
        },
    },
    getters: {
        wrongAnswerLimit() {
            if (!this.currentSection) {
                return Infinity;
            }
            // Note: .38 is based on getting 5/13 wrong.
            return Math.max(3, Math.round(this.currentSection.questions.length * .38));
        },
        correctAnswerLimit() {
            if (!this.currentSection) {
                return Infinity;
            }
            // Note: .7 is based on getting 9/13 correct
            return Math.max(3, Math.round(this.currentSection.questions.length * .7));
        },
        currentSection() {
            if (this.currentSectionIndex === null) {
                return null;
            }
            if (!this.test) {
                return null;
            }
            if (typeof this.test.sections[this.currentSectionIndex] === 'undefined') {
                return null;
            }
            return this.test.sections[this.currentSectionIndex];
        },
        currentQuestion() {
            if (!this.currentSection) {
                return null;
            }
            if (typeof this.currentSection.questions[this.currentQuestionIndex] === 'undefined') {
                return null;
            }
            return this.currentSection.questions[this.currentQuestionIndex];
        },
        totalQuestions() {
            if (!this.test) {
                return 0;
            }
            return this.test.sections.reduce((total, section) => {
                return total + section.questions.length;
            }, 0);
        },
    }
});
